import { SetUtils } from '@common/utils';
import { useEffect, useState } from 'react';

export function useSyncListByUniqueSelection<T, M = T>(args: SyncListByUniqueSelectionArgs<T, M>) {
  const { selection, resources, resourceKey = 'id', mapping } = args;

  const [list, setList] = useState<M[]>([]);

  useEffect(() => {
    let listCopy = [...list];
    const selectionCopy = listCopy.map(({ [resourceKey]: id }) => id);

    // Les IDs sélectionnés de la table qui ne sont pas présents dans la liste ordonnée sont à ajouter dans la liste ordonnée
    const addedKeys = SetUtils.toArray(selection).filter((id) => !selectionCopy.includes(id));
    if (addedKeys.length > 0) {
      const toAdd = resources.reduce((acc, resource) => {
        if (!addedKeys.includes(resource[resourceKey])) return acc;
        acc.push(mapping?.(resource) ?? resource);
        return acc;
      }, []);
      listCopy.push(...toAdd);
    }

    // Les IDs de la liste ordonnée qui ne sont pas présents dans la liste des IDs de la table sont à supprimer de la liste ordonnée
    const deletedKeys = selectionCopy.filter((id) => !selection.has(id));
    if (deletedKeys.length > 0) {
      listCopy = listCopy.filter(({ [resourceKey]: id }) => !deletedKeys.includes(id));
    }

    setList(listCopy);
  }, [selection]);

  return [list, setList];
}

interface SyncListByUniqueSelectionArgs<T extends object, M = T> {
  selection: Set<number | string>
  resources: T[],
  /**
   * @default "id"
   */
  resourceKey?: string;
  mapping?: (resource: T) => M;
}